import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 564,
    },
    '& .modal-base-content': {
        padding: '24px 16px',
    },
});

export const Content = styled('div')({
    display: 'grid',
    gridGap: '16px',
    gridTemplateColumns: '100%',
});

export const DropZone = styled('div', {
    shouldForwardProp: prop => prop !== 'isDragOver',
})(({ isDragOver }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    padding: '32px 16px',
    border: '1px dashed rgba(0, 0, 0, 0.3)',
    borderRadius: 8,
    cursor: 'pointer',
    backgroundColor: isDragOver ? 'rgba(0, 0, 0, 0.04)' : 'transparent',
}));

export const FileRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 12,
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: 8,
});

export const FileDetails = styled('div')({
    display: 'grid',
    gap: 4,
    flex: 1,
    minWidth: 0,
});
